import {useEffect, useState} from "react";
import SessionItem from "./item";
import './index.css'
import {useTranslation} from "react-i18next";
import Loading from "../../../components/loading";
import associateServices from "../../../services";
import {toast} from "react-toastify";
import TableFooter from "../../../components/table-footer/TableFooter";
import InformationToast from "../../../components/toast/InformationToast";

// const statTypes = ['all-bets', 'high-rollers', 'high-winners'];
const SessionSettings = () => {

    const {t} = useTranslation()

    const [loading, setLoading] = useState(true)
    const [submitting, setSubmitting] = useState(false)
    const [limit] = useState(10)
    const [page, setPage] = useState(1)
    const [data, setData] = useState([])
    const [total, setTotal] = useState(0)

    const handlePrev = () => {
        setPage(prevState => prevState <= 1 ? 1 : prevState - 1)
    }
    const handleNext = () => {
        setPage(prevState => prevState + 1)
    }

    const handleApiResponse = res => {
        setData(res?.data?.data || [])
        setTotal(res?.data?.total || 0)
        setLoading(false)

    }

    useEffect(() => {
        fetchData()
    }, [page, limit])


    const fetchData = () => {
        setLoading(true)
        associateServices.getSessions({
            page,
            limit
        }).then(handleApiResponse)
    }


    const handleRevokeResponse = response => {
        setSubmitting(false)
        if (response?.status === 200) {
            fetchData()
            return toast(<InformationToast
                title={t('settings.sessions.revoked-title')}
                message={t('settings.sessions.revoked-message')}
            />)
        }

        return toast.error(t(`api-notifications.${response?.errors}`))

    }
    const handleRevoke = session => {
        if (submitting)
            return false;
        setSubmitting(true)
        associateServices.deactivateSession(session).then(handleRevokeResponse)
    }


    return (
        <div
            className="tab-pane fade show active"
            id="tab-5"
            role="tabpanel"
            aria-labelledby="5-tab"
            tabIndex={0}
        >
            <div className="tab-content">
                <div className="tab-pane fade show active">
                    {
                        loading ? <Loading/> :
                            <div className="table-responsive">
                                <table className="xtable">
                                    <thead>
                                    <tr>
                                        <th>{t(`settings.sessions.browser`)}</th>
                                        <th>{t(`settings.sessions.country`)}</th>
                                        <th>{t(`settings.sessions.ip`)}</th>
                                        <th>{t(`settings.sessions.time`)}</th>
                                        <th>{t(`settings.sessions.status`)}</th>
                                        <th>{t(`settings.sessions.action`)}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        data?.map(stat => <SessionItem stat={stat}
                                                                       onClick={e => handleRevoke(stat)}
                                                                       key={stat?.timestamp}/>)
                                    }
                                    </tbody>
                                </table>
                            </div>
                    }

                    <TableFooter
                        total={total}
                        limit={limit}
                        handlePrev={handlePrev}
                        handleNext={handleNext}
                        page={page}
                        section={'session'}
                        buttonText={t('settings.sessions.download')}
                    />
                </div>

            </div>
        </div>


    )

}

export default SessionSettings
